import React from 'react';
import ReactDOM from 'react-dom/client';
import './main.global.css';
import { App } from './App';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <HashRouter>
    <App />
  </HashRouter>
);